/**
 * 비동기 작업을 로딩 상태로 감싸 실행하는 범용 헬퍼.
 *
 * @param setLoadingStateCb 로딩 상태 setter (true/false로 호출됨)
 * @param asyncAction       실행할 비동기 함수
 * @param successCb         성공 시 결과를 받는 콜백 (선택)
 * @param errorCb           실패 시 에러를 받는 콜백 (선택)
 */
export const actionInAsyncGap = async (
  setLoadingStateCb,
  asyncAction,
  successCb = null,
  errorCb = null,
) => {
  setLoadingStateCb(true);

  let actionResult;
  try {
    actionResult = await asyncAction();
    if (successCb) {
      successCb(actionResult);
    }
  } catch (error) {
    if (errorCb) {
      errorCb(error);
    }
  }

  setLoadingStateCb(false);
  return actionResult;
};

export default actionInAsyncGap;
